<template>
  <div id="unWayBill">
    <header>
      <div class="content">
        <span>欢迎使用中资云企业综合服务平台</span>
      </div>
    </header>
    <section class="content">
      <div class="title flex-between-center">
        <div class="left flex-align-center">
          <img src="../assets/imgs/authentication/logo.png" alt />
          <h2>发放调运单</h2>
        </div>
        <span @click="goHome">平台首页</span>
      </div>
      <!-- 步骤条 -->
      <div class="progress flex-between">
        <div class="backBox">
          <Icon type="ios-arrow-back" />
          <span @click="back">返回</span>
        </div>
        <div class="item" :class="step==1?'active':''" @click="clickTap(1)">
          <div class="step" v-show="step==1">1</div>
          <div class="stepFinish" v-show="step!=1">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>填写调运单</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step==2?'active':''" @click="clickTap(2)">
          <div class="step" v-show="step==1 || step==2">2</div>
          <div class="stepFinish" v-show="step==3 || step==4">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>选择调运车辆</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step==3?'active':''" @click="clickTap(3)">
          <div class="step" v-show="step!=4">3</div>
          <div class="stepFinish" v-show="step==4">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>确认调运信息</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step==4?'active':''" @click="clickTap(4)">
          <div class="step">4</div>
          <!-- <div class="stepFinish" v-show="step">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div> -->
          <span>生成过站码</span>
        </div>
      </div>
      <div class="progressBox" v-if="step==1">
        <p class="head">发放调运单</p>
        <div class="progressContent">
          <Form ref="billForm" :model="billForm" :rules="ruleValidate">
            <div class="flex-between-center">
              <FormItem label="交易矿种" prop="oreId">
                <Select v-model="billForm.oreId" filterable label-in-value @on-change="selectOre">
                  <Option :value="item.oreId" v-for="(item,i) in oreList" :key="i">{{item.oreName}}</Option>
                </Select>
              </FormItem>
              <FormItem label="调运单有效期" prop="validHours">
                <Select v-model="billForm.validHours">
                  <Option :value="item.value" v-for="(item,i) in timeList" :key="i">{{item.name}}</Option>
                </Select>
              </FormItem>
            </div>
            <div class="flex-between">
              <FormItem label="调运企业" prop="enterpriseName">
                <Input type="text" v-model="billForm.enterpriseName" placeholder="调运企业" disabled></Input>
              </FormItem>
              <FormItem label="需方企业" prop="buyerName">
                <!-- <Select v-model="billForm.buyerId" filterable label-in-value @on-change="selectBuyer">
                  <Option :value="item.ID" v-for="(item,i) in erpriseList" :key="i">{{item.ENTERPRISE_NAME}}</Option>
                </Select> -->
                <Input type="text" @on-focus="onFocus" @on-change="inputKey" @on-blur="onBlur" v-model="billForm.buyerName">
                </Input>
                <div style="position: relative;">
                  <!-- <div class="titleColor" style="opacity: 0;">*请仔细确认预申报矿种信息，避免错误给您带来不便</div> -->
                  <div class="toastBox" :style="{display:onfocus}">
                    <div v-if="erpriseList.length>0">
                      <p v-for="(item,i) in erpriseList" @click="selectCompany(item.ENTERPRISE_NAME,item.ENTERPRISE_CODE)" :key="i">
                        {{item.ENTERPRISE_NAME}}</p>
                    </div>
                    <p v-if="erpriseList<=0">暂无数据</p>
                  </div>
                </div>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="装运地" prop="sourceArea">
                <Input autocomplete="on" name="sourceArea" type="text" v-model="billForm.sourceArea" placeholder="装运地" ></Input>
              </FormItem>
              <FormItem label="目的地" prop="destArea">
                <Input autocomplete="on" name="destArea" type="text" v-model="billForm.destArea" placeholder="目的地" ></Input>
              </FormItem>
            </div>
            <Button type="primary" class="next" @click="next">下一步</Button>
          </Form>
        </div>
      </div>
      <div class="progressBox" v-if="step==2">
        <p class="head">发放调运单</p>
        <div class="progressContent1"></div>
        <div class="contentBox">
          <div class="billBox">
            <div class="billLeft">
              <div>
                <div class="billTit">企业账户余额（元）</div>
                <div class="errorBox">
                  <div class="contentTxt" v-show="Number(blance)>Number(taxation)">
                    {{blance.toFixed(2)}}</div>
                  <div class="errorNum" v-show="Number(blance)<Number(taxation)">
                    {{blance.toFixed(2)}}</div>
                  <div class="errorMsg" v-show="Number(blance)<Number(taxation) || Number(blance)==0">* 企业账户余额不足，请及时充值
                  </div>
                </div>
              </div>
              <div class="lineItem">
                <div class="billTit">交易矿种</div>
                <div class="contentTxt">{{billForm.oreName}}</div>
              </div>
            </div>
            <div class="billRight">
              <div>
                <div class="billTit">本次预计税额（元）</div>
                <div class="errorBox">
                  <div class="contentTxt" v-show="Number(blance)>=Number(taxation)">{{taxation.toFixed(2)}}</div>
                  <div class="errorNum" v-show="Number(blance)<Number(taxation)">{{taxation.toFixed(2)}}</div>
                </div>
              </div>
              <div>
                <div class="billTit">本次预计调运量（吨）</div>
                <div class="contentTxt">{{totalTon.toFixed(2)}}</div>
              </div>
            </div>
          </div>
          <div class="addCarBox">
            <div class="addTitle">
              <div class="titleLeft">
                <div class="addCar">
                  <Input v-model="searchPlateNum" placeholder="请输入车牌号" @on-keyup="getSearchPlateNum"></Input>
                  <Button class="addBut" @click="addCar">添加车辆</Button>
                  <div class="searchBox" v-show="searchPlateNumShow" v-on-clickaway="closeShow">
                    <div class="searchTitle">
                      <div class="titleItem">车牌号码</div>
                      <div class="titleItem">车辆编号</div>
                    </div>
                    <ul class="searchUl">
                      <li class="searchList" v-for="(item,i) in carList" :key="i" @click="selectCarNum(item.plateNum)" :class="{'gray':item.lockFlag==1}">
                        <div v-show="item.lockFlag!=1">
                          <span :class="{'active':key==searchPlateNum}" v-for="(key,index) in item.number" :key="index">{{key}}</span>
                        </div>
                        <div v-show="item.lockFlag==1">{{item.plateNum}}</div>
                        <span>{{item.truckCode}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <p class="errMsg" v-show="error">提示：添加车辆信息不存在</p>
              </div>
              <Button class="addsBut" @click="addModalShow">
                <Icon type="ios-add-circle-outline" class="icon" />批量添加
              </Button>
            </div>
            <div class="table">
              <Table max-height="" :loading="loading1" border stripe :columns="tableHead" :data="tableData">
                <template slot-scope="{ row }" slot="plateNum">
                  <span>{{ row.plateNum }}</span>
                  <img src="../assets/imgs/bill/commImg.png" alt="" v-show="row.isCommonCar==1" class="commImg">
                </template>
                <template class="flexr0c" slot-scope="{ row, index }" slot="action">
                  <div class="flexr0c icon-box actionBox">
                    <div @click="del(index)">
                      <span class="iconfont icon">&#xe603;</span>
                      <span class="tips ">删除</span>
                    </div>
                    <div @click="useCar(row.plateNum)" class="actionBut" v-if="row.isCommonCar==0">
                      <Icon type="md-add-circle" class="icon" />
                      <span class="tips ">常用车辆</span>
                    </div>
                  </div>
                </template>
              </Table>
            </div>
            <div class="butBox">
              <Button class="backBut" @click="clickTap(1)">上一步</Button>
              <Button class="nextBut" disabled v-show="nextStep==false">下一步</Button>
              <Button class="nextButTrue" v-show="nextStep" @click="step=3">下一步</Button>
            </div>
          </div>
        </div>
      </div>
      <div class="progressBox" v-if="step==3">
        <p class="head">发放调运单</p>
        <div class="progressContent1"></div>
        <div>
          <div class="detailBox">
            <div class="topBox">
              <div class="detailTitle">调运详情</div>
              <div class="detailContent">
                <div class="line">
                  <div class="labelBox">
                    <span class="label">矿种</span>
                    <span>：</span>
                  </div>
                  <div class="contentTxt redTxt">{{billForm.oreName}}</div>
                </div>
                <div class="line">
                  <div class="labelBox">
                    <span class="label">有效期</span>
                    <span>：</span>
                  </div>
                  <div class="contentTxt">{{billForm.validHours}}小时</div>
                </div>
                <div class="line">
                  <div class="labelBox">
                    <span class="label">装运地</span>
                    <span>：</span>
                  </div>
                  <div class="contentTxt">{{billForm.sourceArea}}</div>
                </div>
                <div class="line">
                  <div class="labelBox">
                    <span class="label">目的地</span>
                    <span>：</span>
                  </div>
                  <div class="contentTxt">{{billForm.destArea}}</div>
                </div>
                <div class="line">
                  <div class="labelBox">
                    <span class="label">需方企业</span>
                    <span>：</span>
                  </div>
                  <div class="contentTxt">{{billForm.buyerName}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="table showTable">
            <Table max-height="" :loading="loading1" border stripe :columns="tableHead3" :data="tableData">
              <template slot-scope="{ row }" slot="plateNum">
                <span>{{ row.plateNum }}</span>
                <img src="../assets/imgs/bill/commImg.png" alt="" v-show="row.isCommonCar==1" class="commImg">
              </template>
            </Table>
          </div>
          <div class="butBox">
            <Button class="backBut" @click="clickTap(2)">上一步</Button>
            <Button class="submitBut" @click="submit" :loading="subMitLoad">提交</Button>
          </div>
        </div>
      </div>
      <div class="progressBox" v-if="step==4">
        <p class="head">发放调运单</p>
        <div class="progressContent1"></div>
        <div class="contentBox1">
          <div class="topBox">
            <div class="codeBox">
              <div class="codeTitle">过站验证码</div>
              <div class="codeContent">
                <div class="codeNum">{{codeNum}}</div>
                <span class="codeMsg">温馨提示：验证码为有效验证信息，请妥善保管，并及时通知相关司机。</span>
              </div>
            </div>
            <div class="codeDetailBox">
              <div class="codeTitle">调运详情</div>
              <div class="detailContentBox">
                <div class="boxTop">
                  <div class="topLeftBox">
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">矿种</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{billForm.oreName}}</div>
                    </div>
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">有效期</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{billForm.validHours}}小时</div>
                    </div>
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">装运地</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{billForm.sourceArea}}</div>
                    </div>
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">目的地</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{billForm.destArea}}</div>
                    </div>
                  </div>
                  <div class="topRightBox">
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">预计调运量</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{totalTon.toFixed(2)}}吨</div>
                    </div>
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">预计税费</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{taxation.toFixed(2)}}元</div>
                    </div>
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">调运企业</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{billForm.enterpriseName}}</div>
                    </div>
                    <div class="line">
                      <div class="labelBox">
                        <span class="label">需方企业</span>
                        <span>：</span>
                      </div>
                      <div class="contentTxt">{{billForm.buyerName}}</div>
                    </div>
                  </div>
                </div>
                <div class="boxBottom">
                  <div class="numBox">
                    <div class="numTitle">当前企业账户余额（元）</div>
                    <div class="yellowNum">{{blance.toFixed(2)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table">
            <Table max-height="" :loading="loading1" border stripe :columns="tableHead3" :data="tableData">
              <template slot-scope="{ row }" slot="plateNum">
                <span>{{ row.plateNum }}</span>
                <img src="../assets/imgs/bill/commImg.png" alt="" v-show="row.isCommonCar==1" class="commImg">
              </template>
            </Table>
          </div>
          <Button class="comFirmBut" @click="toTable">确认</Button>
        </div>
      </div>
    </section>
    <foot></foot>
    <Modal v-model="carsModal" width="488" class-name="vertical-center-modal">
      <p slot="header" style="text-align:center;">
        <span style="color: white;font-size: 18px;font-weight: 600;">批量添加常用车辆</span>
      </p>
      <div class="modalContent">
        <div class="table">
          <Table max-height="" :loading="loading1" border stripe :columns="modalTableHead" :data="commonList" @on-select-all="handleSelectAll" @on-select="selectedArr" @on-selection-change="selectedArr">
            <template slot-scope="{ row }" slot="plateNum">
              <div :class="row.lockFlag==1?'gray':''">{{ row.plateNum }}</div>
            </template>
            <template slot-scope="{ row }" slot="truckCode">
              <div :class="row.lockFlag==1?'gray':''">{{ row.truckCode }}</div>
            </template>
            <template slot-scope="{ row }" slot="avgWeight">
              <div :class="row.lockFlag==1?'gray':''">{{ row.avgWeight }}</div>
            </template>
          </Table>
          <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
              <Page :total="commonTotal" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total>
              </Page>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div style="display: flex;justify-content: center;">
          <Button style="width: 138px;" @click="carsModal=false">取消</Button>
          <Button style="width: 138px;background-image: linear-gradient(180deg, #478EE9 0%, #2255CE 100%);color: white;" :loading="modal_loading" @click="modalAdd">添加</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import foot from "../components/footer";
import { mapState, mapMutations, mapActions } from "vuex";
// 搜索高亮
const getInf = (str, key) => str.toString().replace(new RegExp(`${key}`, 'g'), `%%${key}%%`).split('%%');
export default {
  data () {
    return {
      onfocus: 'none',
      modal_loading: false,
      total: 0,
      pageSize: 10,
      searchPlateNum: "",
      searchPlateNumShow: false,
      carsModal: false,
      step: 1,
      billForm: {
        buyerName: "",
        buyerId: ""
      },
      ruleValidate: {
        oreId: [
          { required: true, message: '交易矿种不能为空', trigger: 'change' }
        ],
        validHours: [
          { required: true, message: '调运单有效期不能为空', trigger: 'change' }
        ],
        enterpriseName: [
          { required: true, message: '调运企业不能为空', trigger: 'blur' }
        ],
        buyerName: [
          { required: true, message: '需方企业不能为空', trigger: 'change' }
        ],
        sourceArea: [
          { required: true, message: '装运地不能为空', trigger: 'blur' }
        ],
        destArea: [
          { required: true, message: '目的地不能为空', trigger: 'blur' }
        ]
      },
      loading1: false,
      tableHead3: [{
        title: "车牌号码",
        slot: "plateNum",
        resizable: true,
      },
      {
        title: "车辆编号",
        key: "truckCode",
        resizable: true,
      },
      {
        title: "车辆类型",
        key: "truckTypeName",
        resizable: true,
      },
      {
        title: "车辆载重（吨）",
        key: "avgWeight",
        resizable: true,
      },
      {
        title: "预计吨数",
        key: "avgWeight",
        resizable: true,
      },
      ],
      tableHead: [{
        title: "车牌号码",
        slot: "plateNum",
        resizable: true,
      },
      {
        title: "车辆编号",
        key: "truckCode",
        width: 120,
        resizable: true,
      },
      {
        title: "车辆类型",
        key: "truckTypeName",
        width: 120,
        resizable: true,
      },
      {
        title: "车辆载重（吨）",
        key: "avgWeight",
        resizable: true,
      },
      {
        title: "操作",
        slot: "action",
        resizable: true,
      }
      ],
      tableData: [],
      modalTableHead: [{
        type: 'selection',
        width: 60,
        align: 'center'
      },
      {
        title: "车牌号码",
        slot: "plateNum",
        resizable: true,
      },
      {
        title: "车辆编号",
        slot: "truckCode",
        resizable: true,
      },
      {
        title: "车辆载重(吨)",
        slot: "avgWeight",
        resizable: true,
      },
      ],
      commonList: [],
      commonTotal: 0,
      session: {},
      oreList: [],
      timeList: [
        { value: "2", name: "2小时" },
        { value: "5", name: "5小时" },
        { value: "8", name: "8小时" },
        { value: "12", name: "12小时" },
        { value: "24", name: "24小时" },
        { value: "72", name: "72小时" },
      ],
      erpriseList: [],
      blance: 0,
      tax: "",
      commonKeyword: "",
      carList: [],
      error: false,
      totalTon: 0,
      taxation: 0,
      nextStep: false,
      modalArr: [],
      codeNum: "",
      subMitLoad: false,
      creditState: false
    }
  },
  created () {
    this.session = JSON.parse(localStorage["session"]);
    if (this.session) {
      this.getOreList();
      this.inquireEnterprise();
      this.billForm.enterpriseName = this.session.enterpriseName;
      this.billForm.enterpriseId = this.session.enterpriseId;     //调运企业id
    }
  },
  mounted () {
    window.sessionStorage.setItem('from', 'unWayBill');
	
  },
  methods: {
    ...mapMutations(["setContentType", "setMenuName",]),
    back () {
      window.sessionStorage.setItem('from', 'unWayBill');
      this.$router.push("/home");
    },
    onFocus () {
      this.$nextTick(() => {
        this.onfocus = 'block';
      });
    },
    onBlur () {
      setTimeout(() => {
        this.onfocus = 'none';
      }, 200);
    },
    //需方企业输入事件
    inputKey: function (key) {
      this.inquireEnterprise(key.data);
    },
    selectCompany (name, code) {
      this.billForm.buyerName = name;
    },
    // 查询需方企业
    inquireEnterprise: function (key) {
      let data = {
        sessionId: this.session.sessionId,
        modeCode: 'Il9LhbAju1Qa9XCqFEb6CPSTFnxJxWwR',
        enterpriseId: this.session.enterpriseId,
        keyword: key || ''
      }
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.erpriseList = res.data;
          }
        })
    },
    toTable () {
      window.history.go(-1);
    },
    // 全选
    handleSelectAll (all) {
      this.modalArr = all;
    },
    selectedArr (sel) {
      this.modalArr = sel;
    },
    submit () {
      this.subMitLoad = true;
      this.erpriseList.forEach((item) => {
        if (item.ENTERPRISE_NAME == this.billForm.buyerName) {
          this.billForm.buyerId = item.ID;
        }
      });
      let plateNumArr = [];
      let weightArr = [];
      this.tableData.forEach(ele => {
        plateNumArr.push(ele.plateNum);
        weightArr.push(ele.avgWeight);
      });
      let data = {
        sessionId: this.session.sessionId,
        modeCode: "VsRojaA8d7ZDDkFsTuc7LUzQyVMErfFu",
        plateNums: plateNumArr.join(","),
        weights: weightArr.join(","),
        ...this.billForm
      }
      this.$http.post(data).then(res => {
        this.subMitLoad = false;
        if (res.code == 1) {
          this.codeNum = res.data;
          this.getBalance();
          this.step = 4;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      })
    },
    clickTap (index) {
      if (this.step == 2) {     //step=2时可以切1
        if (index == 1) {
          this.searchPlateNum = "";
          this.tableData = [];
          this.totalTon = 0;
          this.taxation = 0;
          this.step = 1;
        }
      } else if (this.step == 3) {   //step=3可切1、2
        if (index == 1) {
          this.searchPlateNum = "";
          this.tableData = [];
          this.totalTon = 0;
          this.taxation = 0;
          this.step = 1;
        } else if (index == 2) {
          this.step = 2;
        }
      }
    },
    del (index) {
      this.tableData.splice(index, 1);
    },
    // 设置常用车辆
    useCar (plateNum) {
      this.$http.post({
        sessionId: this.session.sessionId,
        modeCode: "S6DC4yxFk3P71XPwE0pc3OTyEY3JeHEO",
        plateNum: plateNum,
        userId: this.session.userId
      }).then(res => {
        if (res.code == 1) {
          this.tableData = this.tableData.map(ele => {
            if (ele.plateNum == plateNum) {
              ele.isCommonCar = 1;        //成为则为常用车辆
            }
            return ele;
          });
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      })
    },
    addModalShow () {
      this.getCommonCar();
      this.carsModal = true;
    },
    selectBuyer (val) {
      this.billForm.buyerName = val.label;
    },
    selectOre (val) {
      this.billForm.oreName = val.label;
    },
    next () {
      this.$refs["billForm"].validate((valid) => {
        if (valid) {
          let info;
          // 判断选中的矿种有没有税率
          this.oreList.forEach(ele => {
            if (ele.oreId == this.billForm.oreId) {
              info = ele;
            }
          });
          if (info.taxSumMoney) {
            this.step = 2;
          } else {
            this.$Message['error']({
              background: true,
              content: "该矿种没设置税率,请联系市县工作人员设置税率！"
            });
          }
        }
      })
    },
    closeShow () {
      this.searchPlateNumShow = false;
    },
    // 数组去重
    unique (arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.plateNum) && res.set(arr.plateNum, 1))
    },
    selectCarNum (plateNum) {
      // 判断是否黑名单
      let arr = [];
      arr = this.carList.filter(ele => {
        return plateNum == ele.plateNum;
      });
      if (arr[0].lockFlag == 1) {
        this.$Message['error']({
          background: true,
          content: "黑名单车辆不允许添加！"
        });
      } else {
        this.searchPlateNum = plateNum;
        this.searchPlateNumShow = false;
      }
    },
    modalAdd () {
      if (this.modalArr.length > 0) {
        if (this.tableData.length > 0) {
          let arr = this.tableData.concat(this.modalArr);
          arr = this.unique(arr);
          this.tableData = arr;
        } else {
          this.tableData.push(...this.modalArr);
        }
        this.carsModal = false;
      } else {
        this.$Message['error']({
          background: true,
          content: "请至少选择一项！"
        });
      }
    },
    addCar () {
      // 判断该车辆是否存在
      let arr = [];
      arr = this.carList.filter(ele => {
        return this.searchPlateNum == ele.plateNum;
      });
      if (arr.length > 0) {
        // 判断是否黑名单
        if (arr[0].lockFlag != 1) {
          this.error = false;
          let selectedArrInfo = [];
          this.carList.forEach(ele => {
            if (ele.plateNum == this.searchPlateNum) {
              selectedArrInfo.push(ele);
            }
          });
          if (this.tableData.length > 0) {
            let arr = this.tableData.concat(selectedArrInfo);
            arr = this.unique(arr);
            this.tableData = arr;
          } else {
            this.tableData.push(...selectedArrInfo);
          }
          this.searchPlateNum = "";
        } else {
          this.$Message['error']({
            background: true,
            content: "黑名单车辆不允许添加！"
          });
        }
      } else {
        this.error = true;
      }
    },
    // 查询车辆
    getCarList () {
      let data = {
        sessionId: this.session.sessionId,
        modeCode: "dbDzzOte6qzHNWfJggWa9b1djiplSTOe",
        sessionId: this.session.sessionId,
        userId: this.session.userId,
        keyword: this.searchPlateNum
      }
      this.$http.post(data).then(res => {
        if (res.code == 1) {
          this.searchPlateNumShow = true;
          res.data = res.data.map(ele => {
            ele.number = getInf(ele.plateNum, this.searchPlateNum);
            return ele;
          });
          this.carList = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      })
    },
    // 查询常用车辆
    getCommonCar () {
      this.$http.post({
        sessionId: this.session.sessionId,
        modeCode: "Ilndp2lKoDeTqiwhGyPsnHzl4KuK5JRM",
        userId: this.session.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyword: this.commonKeyword
      }).then(res => {
        if (res.code == 1) {
          res.data.list = res.data.list.map(ele => {
            ele.truckTypeName = ele.truckType;
            ele.isCommonCar = 1;
            ele.lockFlag == 1 ? ele._disabled = true : "";      //黑名单车辆禁止选中
            return ele;
          });
          // 判断是否已经有已选中的
          if (res.data.list.length > 0 && this.tableData.length > 0) {
            this.commonList = res.data.list.map(ele => {
              this.tableData.forEach(item => {
                if (item.plateNum == ele.plateNum) {
                  ele._checked = true;
                  this.modalArr.push(ele);
                }
              });
              return ele;
            })
          } else {
            this.commonList = res.data.list;
          }
          this.commonTotal = res.data.count;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      })
    },
    goHome () {
      window.sessionStorage.removeItem('from');
      this.setContentType(0)
      this.$router.push("/home");
    },
    // 查余额
    getBalance () {
      this.$http.post({
        sessionId: this.session.sessionId,
        modeCode: "QNm7EaHrPE7erFIeBunIyZznVscreiKl",
        oreId: this.billForm.oreId,
        enterpriseId: this.session.enterpriseId
      }).then(res => {
        if (res.code == 1) {
          this.creditState = res.data.creditState; // 授信
          this.blance = res.data.blance;        // 余额
          this.tax = res.data.tax;              // 税率
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      })
    },
    // 矿种
    getOreList () {
      this.$http.post({
        sessionId: this.session.sessionId,
        modeCode: "NEKPI3BNTyQIj9lRgMmZI9jzmhrp3vjJ",
        userId: this.session.userId
      }).then(res => {
        if (res.code == 1) {
          this.oreList = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      })
    },
    changePage (page) {
      this.pageIndex = page;
      this.getCommonCar();
    },
    getSearchPlateNum () {
      if (this.searchPlateNum.length > 2) {
        this.getCarList();
        this.searchPlateNumShow = true;
      }
    },
  },
  components: {
    foot
  },
  watch: {
    step (newVal) {
      // 进度2
      if (newVal == 2) {
        this.getBalance();
        this.getCommonCar();
      }
    },
    // 监听表计算调运量、税率
    tableData (newVal) {
      if (newVal) {
        let totalTon = 0;         // 调运量
        let taxation = 0;         // 税率
        if (newVal.length > 0) {
          newVal.forEach(ele => {
            if (ele.avgWeight) {
              totalTon += Number(ele.avgWeight);
            }
          });
          this.totalTon = totalTon;
          this.taxation = this.tax * totalTon;
          if (this.creditState) {
            this.nextStep = true;
          } else {
            if (Number(this.blance) < this.taxation && newVal.length != 0) {
              this.nextStep = false;
            } else {
              this.nextStep = true;
            }
          }
        } else {
          this.nextStep = false;
          this.totalTon = 0;
          this.taxation = 0;
        }
      }
      deep: true;
    }
  }
}
</script>

<style lang="less" scoped>
#unWayBill {
  header {
    background: #f7f9fd;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #616c84;
    letter-spacing: -0.43px;
  }
  section {
    margin: 40px auto;
  }
  .title {
    margin: 20px 0;

    .left {
      font-family: PingFangSC-Regular;
      color: #252a37;
      letter-spacing: 0.39px;

      h2 {
        margin-left: 15px;
      }
    }

    span {
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #2c59c3;
      letter-spacing: 0.26px;
    }
  }

  /* 步骤条 */
  .progress {
    margin: 20px auto;
    border-bottom: 2px solid #d7dce7;
    padding: 0 40px;
    height: 35px;
    line-height: 30px;
    cursor: pointer;
    position: relative;
    .backBox {
      position: absolute;
      top: -16px;
      left: 4px;
      width: 100px;
    }
    .item {
      width: 210px;
      display: flex;
      align-items: center;
      padding: 5px 12px;

      span {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #252a37;
        margin-left: 10px;
        letter-spacing: 0.29px;
      }

      /* 步骤序号 */
      .step {
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #b0b5c1;
        color: #fff;
        border-radius: 50%;
        text-align: center;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.29px;
      }
    }

    .line {
      margin: 0 30px;
    }

    /* 进度条激活样式 */
    .item.active {
      border-bottom: 2px solid #2c59c3;
      margin-bottom: -2px;

      .step {
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
      }
    }

    /* 进度条完成样式 */
    //   .stepFinish {
    //     display: none;
    //   }
    .stepFinish img {
      vertical-align: middle;
    }
  }

  .progressBox {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 10px 90px 0 rgba(29, 42, 67, 0.05);
    padding: 20px;

    .head {
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #2c59c3;
      letter-spacing: 0.36px;
      text-align: center;
      font-weight: 600;
    }
    .toastBox {
      // display: none;
      cursor: pointer;
      overflow-y: scroll;
      background-color: white;
      min-width: 368px;
      position: absolute;
      z-index: 999;
      top: 3px;
      left: 0px;
      height: 200px;
      padding: 10px 0;
      box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.07);
      p {
        padding: 0 10px;
      }
      & > p:hover {
        background: #f3f3f3;
        cursor: pointer;
      }
    }
    .progressContent {
      width: 860px;
      margin: 20px auto 30px;
      padding: 15px 0;
      border-top: 1px solid #ebedf3;

      // 表单label样式
      /deep/ .ivu-form .ivu-form-item-label {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #616c84;
        letter-spacing: 0.26px;
        line-height: 20px;
      }

      .ivu-form-item {
        width: 368px;
      }

      /deep/ .ivu-input {
        height: 48px;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      }

      /deep/ .ivu-select-single .ivu-select-selection {
        height: 48px;
        line-height: 48px;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      }

      /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        line-height: 48px;
      }

      /deep/ .ivu-date-picker {
        display: block;
      }

      /deep/ .ivu-input-suffix {
        line-height: 48px;
      }

      /deep/ .ivu-select-dropdown {
        top: 84px !important;
      }

      // input禁用字体样式
      /deep/ .ivu-input[disabled],
      fieldset[disabled] .ivu-input {
        color: #4a4a4a;
        font-size: 14px;
        font-family: PingFangSC-Semibold;
      }

      .next {
        display: block;
        width: 368px;
        margin: 30px auto;
        height: 48px;
      }
    }

    .progressContent1 {
      width: 860px;
      margin: 20px auto 30px;
      border-top: 1px solid #ebedf3;
    }

    .contentBox {
      width: 928px;
      margin: auto;

      .billBox {
        background: #f4f4f6 url('../assets/imgs/bill/unbllBg.png') no-repeat;
        background-size: 100% 100%;
        width: 565px;
        height: 200px;
        box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
        box-sizing: border-box;
        padding: 40px;
        display: flex;
        .billTit {
          font-size: 15px;
        }
        .billLeft {
          width: 50%;
          border-right: 1px solid #ebedf3;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .billRight {
          box-sizing: border-box;
          padding: 0 45px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .errorBox {
          font-family: PingFangSC-Regular;
          // color: #af2534;
          .errorNum {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #d0021b;
            letter-spacing: 0.34px;
            font-weight: 600;
          }

          .errorMsg {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #af2534;
          }
        }

        .contentTxt {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #25265e;
          letter-spacing: 0.34px;
          font-weight: 600;
        }
      }
    }

    .addCarBox {
      width: 928px;
      margin: 30px auto;

      .addCar {
        position: relative;

        /deep/ .ivu-input {
          height: 48px;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          padding-left: 20px;
        }

        display: flex;
        width: 368px;

        .addBut {
          background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
          border: 1px solid #4c9b25;
          border-radius: 6px;
          color: #fff;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          width: 110px;
          height: 48px;
        }

        .searchBox {
          position: absolute;
          top: 45px;
          left: 0;
          width: 240px;
          height: 270px;
          border: 1px solid red;
          z-index: 999;
          background: #ffffff;
          border: 1px solid #dadada;
          box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);
          border-radius: 10px;
          overflow: hidden;

          .searchTitle {
            display: flex;
            background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
            height: 30px;
            line-height: 30px;
            border-radius: 10px 10px 0 0;

            .titleItem {
              font-weight: 600;
              width: 50%;
              box-sizing: border-box;
              padding: 0 20px;
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #4a4a4a;
              letter-spacing: 0.26px;
            }

            .titleItem:first-child {
              border-right: 1px solid #dadada;
            }
          }

          .searchUl {
            height: 240px;
            overflow-y: auto;

            .searchList:hover {
              background: #fafafa;
              // color: #4a4a4a;
              // font-weight: 600;
            }

            .searchList {
              cursor: pointer;
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #dadada;
              box-sizing: border-box;
              display: flex;
              justify-content: space-around;
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #999999;
              letter-spacing: 0.26px;
              .active {
                color: #2969b0;
                font-weight: 600;
              }
            }
            .searchList.gray {
              background: #e8e9ea;
            }
          }
        }
      }

      .addTitle {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .titleLeft {
          display: flex;
          align-items: center;
        }

        .errMsg {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #af2534;
          margin-left: 20px;
        }

        .addsBut {
          background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
          border: 1px solid #4c9b25;
          border-radius: 6px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;

          .icon {
            margin-right: 10px;
          }
        }
      }

      .table {
        margin-top: 10px;

        .commImg {
          vertical-align: middle;
          margin-left: 5px;
        }

        .actionBox {
          cursor: pointer;

          .actionBut {
            margin-left: 20px;
          }

          .icon {
            margin-right: 5px;
          }
        }
      }
      .butBox {
        display: flex;
        width: 500px;
        margin: 20px auto;
        .backBut {
          height: 48px;
          width: 200px;
          margin-right: 20px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #2255ce;
          letter-spacing: 0.3px;
          border: 1px solid #2255ce;
          border-radius: 8px;
        }
        .nextBut {
          background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
          border: 1px solid #b2c9ff;
          border-radius: 8px;
          display: block;
          width: 280px;
          height: 48px;
          // margin: 20px auto;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.3px;
        }

        .nextButTrue {
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #b2c9ff;
          border-radius: 8px;
          display: block;
          width: 280px;
          height: 48px;
          // margin: 20px auto;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.3px;
        }
      }
    }

    .detailBox {
      width: 928px;
      margin: auto;
      background: #ffffff;
      box-sizing: border-box;

      .topBox {
        width: 484px;
        height: 220px;
        background: #ffffff;
        box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
        border-radius: 10px;

        .detailTitle {
          height: 40px;
          line-height: 40px;
          background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
          border-radius: 10px 10px 0 0;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #60687d;
          letter-spacing: 0.37px;
          box-sizing: border-box;
          padding: 0 18px;
          font-weight: 600;
        }

        .detailContent {
          box-sizing: border-box;
          padding: 16px 18px;

          .line {
            display: flex;
            margin-bottom: 5px;

            .labelBox {
              width: 20%;
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #8b93a7;
              letter-spacing: 0;
              font-weight: 600;

              .label {
                width: 80%;
                display: inline-block;
                text-align: justify;
                text-align-last: justify;
                display: inline-block;
              }
            }

            .contentTxt {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0;
              font-weight: 600;
              margin-left: 10px;
            }

            .redTxt {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #d0021b;
              letter-spacing: 0;
            }
          }
        }
      }
    }

    .showTable {
      width: 928px;
      margin: 30px auto;

      .commImg {
        vertical-align: middle;
        margin-left: 10px;
      }
    }
    .butBox {
      display: flex;
      width: 500px;
      margin: 80px auto;
      .backBut {
        height: 48px;
        width: 200px;
        margin-right: 20px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2255ce;
        letter-spacing: 0.3px;
        border: 1px solid #2255ce;
        border-radius: 8px;
      }
      .submitBut {
        width: 368px;
        height: 48px;
        display: block;
        // margin: 80px auto 20px;
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 8px;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.34px;
      }
    }

    .contentBox1 {
      width: 956px;
      margin: auto;
      box-sizing: border-box;

      .topBox {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .codeBox {
          background: #ffffff;
          box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
          border-radius: 10px;
          width: 400px;
          height: 340px;

          .codeContent {
            box-sizing: border-box;
            text-align: center;

            .codeNum {
              font-family: Impact;
              font-size: 50px;
              color: #d0021b;
              letter-spacing: 1.17px;
              margin: 95px auto 80px;
            }

            .codeMsg {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #616c84;
              letter-spacing: 0;
            }
          }
        }

        .codeTitle {
          height: 40px;
          line-height: 40px;
          box-sizing: border-box;
          font-weight: 600;
          padding: 0 18px;
          background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
          border-radius: 10px 10px 0 0;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #60687d;
          letter-spacing: 0.37px;
        }

        .codeDetailBox {
          background: #ffffff;
          box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
          border-radius: 10px;
          width: 540px;
          height: 340px;
          box-sizing: border-box;

          .detailContentBox {
            box-sizing: border-box;
            padding: 20px 0 20px 18px;

            .boxTop {
              display: flex;

              .topLeftBox {
                width: 35%;
                border-right: 1px solid #ebedf3;

                .line {
                  display: flex;
                  margin-bottom: 5px;

                  .labelBox {
                    font-family: PingFangSC-Semibold;
                    font-size: 16px;
                    color: #8b93a7;
                    letter-spacing: 0;
                    font-weight: 600;

                    .label {
                      width: 60px;
                      display: inline-block;
                      text-align: justify;
                      text-align-last: justify;
                      display: inline-block;
                    }
                  }

                  .contentTxt {
                    font-family: PingFangSC-Semibold;
                    font-size: 16px;
                    color: #4a4a4a;
                    letter-spacing: 0;
                    font-weight: 600;
                    margin-left: 5px;
                  }
                }
              }

              .topRightBox {
                box-sizing: border-box;
                padding-left: 30px;

                .line {
                  display: flex;
                  margin-bottom: 5px;

                  .labelBox {
                    font-family: PingFangSC-Semibold;
                    font-size: 16px;
                    color: #8b93a7;
                    letter-spacing: 0;
                    font-weight: 600;

                    .label {
                      width: 80px;
                      display: inline-block;
                      text-align: justify;
                      text-align-last: justify;
                      display: inline-block;
                    }
                  }

                  .contentTxt {
                    width: 180px;
                    word-wrap: break-word;
                    font-family: PingFangSC-Semibold;
                    font-size: 16px;
                    color: #4a4a4a;
                    letter-spacing: 0;
                    font-weight: 600;
                    margin-left: 5px;
                  }
                }
              }
            }

            .boxBottom {
              display: flex;
              text-align: center;
              border-top: 1px solid #ebedf3;
              margin-top: 40px;
              padding: 15px 0;

              .numBox {
                margin-right: 40px;

                .numTitle {
                  font-family: PingFangSC-Medium;
                  font-size: 14px;
                  color: #8b93a7;
                  letter-spacing: 0.35px;
                }

                .greenNum {
                  font-family: Impact;
                  font-size: 34px;
                  color: #7ed321;
                  letter-spacing: 0.85px;
                  margin-top: 10px;
                }

                .yellowNum {
                  font-family: Impact;
                  font-size: 34px;
                  color: #f5a623;
                  letter-spacing: 0.85px;
                  margin-top: 10px;
                }
              }
            }
          }
        }
      }

      .commImg {
        margin-left: 10px;
        vertical-align: middle;
      }

      .comFirmBut {
        background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
        border: 1px solid #285ed3;
        border-radius: 8px;
        display: block;
        width: 368px;
        height: 48px;
        margin: 40px auto;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0.34px;
      }
    }
  }
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }

  .ivu-btn-primary {
    background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
    margin: 0 10px;
  }

  .ivu-modal-close .ivu-icon-ios-close {
    color: #fff;
  }

  .ivu-modal-footer {
    padding: 10px 18px 10px 18px;
    background: #f5f5f5;
    border-radius: 0px 0px 10px 10px;
  }

  .ivu-modal-header {
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%) !important;
    border-radius: 6px 6px 0 0;
    height: 48px;
  }

  .modalContent {
    box-sizing: border-box;
    padding: 10px;

    .table {
      /deep/ .ivu-table th {
        background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
        color: #3767cb;
        height: 30px;
      }

      /deep/ .ivu-table-header thead tr th {
        padding: 0;
      }

      .ivu-table td {
        height: 40px;
      }
      .gray {
        color: #9b9b9b !important;
      }
    }
  }
}
/deep/ .ivu-select-input {
  height: 48px;
}
/deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  line-height: 48px;
}
</style>
